module.exports = __webpack_public_path__ + "static/media/logo_VietinBank.dd97e265.svg";